"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Poll = void 0;
const utils_1 = require("../../../utils");
var Poll;
(function (Poll) {
    Poll.type = 'poll';
    Poll.maxOptions = 10;
    Poll.resultTypes = ['bar', 'pie', 'scale'];
    function defaultResultForPollType(pollType) {
        return pollType === 'scale' ? 'scale' : 'bar';
    }
    Poll.defaultResultForPollType = defaultResultForPollType;
    function resultTypesForAnswerType(answerType) {
        if (answerType === 'scale') {
            return ['scale'];
        }
        return ['bar', 'pie'];
    }
    Poll.resultTypesForAnswerType = resultTypesForAnswerType;
    function multipleChoiceGridSize(size) {
        return Math.min(10, Math.max(4, Math.ceil(size / 2) * 2));
    }
    Poll.multipleChoiceGridSize = multipleChoiceGridSize;
    let Answer;
    (function (Answer) {
        function optionIsOfType(option, type) {
            return option.type === type;
        }
        Answer.optionIsOfType = optionIsOfType;
        function isDone(answer) {
            return !!answer && typeof answer.value !== 'undefined';
        }
        Answer.isDone = isDone;
        function displayValueForPinAnswerOption(custom, value) {
            switch (custom.answerType) {
                case 'emoji':
                    return { displayValue: custom.options[value], type: 'text' };
                case 'multipleChoice':
                    const option = custom.options[value];
                    if (!option)
                        return undefined;
                    return option.type === 'text'
                        ? { displayValue: option.text, type: 'text' }
                        : { displayValue: option.url, type: 'image', backgroundSize: option.backgroundSize };
                case 'scale':
                    return { displayValue: value?.toString(), type: 'text' };
                default:
                    return undefined;
            }
        }
        Answer.displayValueForPinAnswerOption = displayValueForPinAnswerOption;
        function resultTypesForAnswerType(answerType) {
            if (answerType === 'scale') {
                return ['scale'];
            }
            return ['bar', 'pie'];
        }
        Answer.resultTypesForAnswerType = resultTypesForAnswerType;
        function displayValueForStudentAnswer(pinContent, answer) {
            if (!answer)
                return undefined;
            if (pinContent.answerType === 'scale') {
                return { number: answer.value };
            }
            if (pinContent.answerType === 'emoji') {
                return { text: pinContent.options[answer.value] };
            }
            const option = pinContent.options[answer?.value];
            if (optionIsOfType(option, 'image')) {
                return { image: option.url, backgroundSize: option.backgroundSize };
            }
            return { text: option.text };
        }
        Answer.displayValueForStudentAnswer = displayValueForStudentAnswer;
    })(Answer = Poll.Answer || (Poll.Answer = {}));
    function IsMultipleChoice(pinItem) {
        return pinItem.answerType === 'multipleChoice';
    }
    Poll.IsMultipleChoice = IsMultipleChoice;
    function isOfType(pinItem, type) {
        return pinItem.answerType === type;
    }
    Poll.isOfType = isOfType;
    // TODO: Remove
    // export function createNewItem(): PinItem {
    //   const custom: Content = {
    //     type: 'poll',
    //     question: undefined,
    //     fontSize1: 80,
    //     align: 1,
    //     color: 1,
    //     opacity: 1,
    //     defaultResults: 'bar',
    //     answerType: 'multipleChoice',
    //     optionType: 'text',
    //     options: [],
    //   };
    //   return {
    //     custom,
    //   };
    // }
    Poll.DEFAULT_EMOJI = ['😒', '🙁', '😐', '🙂', '😃'];
    function defaultOptionsForAnswerType(type) {
        switch (type) {
            case 'emoji':
                return Poll.DEFAULT_EMOJI;
            case 'scale':
                return { min: 0, max: 100 };
            case 'multipleChoice':
                return [];
            default:
                return (0, utils_1.assertNever)(type, 'Missing poll option type');
        }
    }
    Poll.defaultOptionsForAnswerType = defaultOptionsForAnswerType;
})(Poll || (exports.Poll = Poll = {}));
//# sourceMappingURL=Poll.js.map